import React, { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faPowerOff, faSearch } from '@fortawesome/free-solid-svg-icons';
import { maskDocument, validateDocument } from 'helpers/document'
import { Button, Card, Col, Container, Row, Form, Alert, Modal, Table, Spinner } from 'react-bootstrap'
import { Clear } from '@material-ui/icons';
import { useCompany, useUser } from 'models';
import ResalesRequestService from 'services/resales-request';
import { Formik, FieldArray, ErrorMessage } from 'formik';
import * as yup from "yup";
import { CNPJ } from 'helpers/Input';
import collect from 'collect.js';

import Swal from 'sweetalert2';

import LoginService from 'services/login';
import DocumentService from 'services/document';
import MaskedInput from 'react-text-mask';
import logo from '../../images/logo/logo_scansource_select_colorido.png'

import './style.css'
import Axios from 'axios';

export default function AccessionFormBkp() {
  const { company } = useCompany()

  const [branches] = useState(() => {
    return collect(company.group_years)
      .where("fiscal_year_id", company.current_fiscal_year.id)
      .where("company_id", '!==', company.id)
      .all()
      .map((branch) => {
        return { id: branch.company_id, name: branch.name, alias: branch.alias, document: branch.document }
      })
  })
  const [users] = useState(() => {
    return collect(company.users)
      .whereIn("profile_id", [4, 6, 7])
      .all()
      .map(({ id, name, lastname, email, phone, profile_id }) => ({ id, name, lastname, email, phone, profile_id }))
  })

  const [isRequesting, setIsRequesting] = useState(false)
  const [contractUri, setContractUri] = useState('')

  const [usersToDelete, setUsersToDelete] = useState([])
  const [companiesToDelete, setCompaniesToDelete] = useState([])

  const [contractAccept, setContractAccept] = useState(false)
  const [menuVisible, setMenuVisible] = useState(false)
  const [showModalSearchCompany, setShowModalSearchCompany] = useState(false)
  const [branche, setBranche] = useState(null)
  const [showModalConfirm, setShowModalConfirm] = useState(false)
  const [confirmData, setConfirmData] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [cancelTokenAvailable, setCancelTokenAvailable] = useState(null)

  useEffect(() => {
    DocumentService.getContract()
      .then(r => {
        setContractUri(r.data.document_url)
      })
  }, [])

  function showCategory(category) {

    return <img src={logo} className="" alt="elite" width="445" />
    // switch (category) {
    //   case 1: return <img src={elite} className="" alt="elite" height="50" />
    //   case 2: return "Elite Gerencial"
    //   case 3: return <img src={scancash} className="" alt="scancash" height="50" />
    //   default: return "Sem categoria"
    // }
  }

  const handleCloseModal = () => setShowModalConfirm(!showModalConfirm)

  const modalConfirm = values => {
    return
    setConfirmData(values)
    setShowModalConfirm(true)
  }

  const _handleSubmit = values => {
    var formData = new FormData()
    formData.append('id', company.id)
    formData.append('name', values.name)
    formData.append('alias', values.alias)
    formData.append('document', values.document)
    formData.append('is_premium', company.is_premium)

    formData.append('address', values.address)
    formData.append('address_number', values.address_number)
    formData.append('address_complement', values.address_complement)
    formData.append('address_neighborhood', values.address_neighborhood)
    formData.append('address_zipcode', values.address_zipcode ? values.address_zipcode.replace('.', '') : "")
    formData.append('address_city', values.address_city)
    formData.append('address_state', values.address_state)

    usersToDelete.forEach((u, i) => {
      formData.append(`users_to_delete[${i}]`, u.id)
    })

    companiesToDelete.forEach((c, i) => {
      formData.append(`companies_to_delete[${i}]`, c.id)
    })

    const branches = values.branches.filter(b => {
      return !companiesToDelete.map(c => c.id).includes(b.id)
    })

    const users = values.users.filter(u => {
      return !usersToDelete.map(u => u.id).includes(u.id)
    })

    branches.forEach((branch, idx) => {
      if (branch.id) {
        formData.append(`branches[${idx}][id]`, branch.id)
      }
      formData.append(`branches[${idx}][name]`, branch.name)
      formData.append(`branches[${idx}][alias]`, branch.alias)
      formData.append(`branches[${idx}][document]`, branch.document)
    })

    users.forEach((user, idx) => {
      formData.append(`users[${idx}][id]`, user.id)
      formData.append(`users[${idx}][name]`, user.name)
      formData.append(`users[${idx}][lastname]`, user.lastname)
      formData.append(`users[${idx}][email]`, user.email)
      formData.append(`users[${idx}][profile_id]`, user.profile_id)
      formData.append(`users[${idx}][phone]`, user.phone ?? "")
    })

    setIsLoading(true)
    ResalesRequestService
      .confirmAdhesion(formData)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Adesão Realizada com sucesso!",
          allowEscapeKey: false,
          allowOutsideClick: false,
          confirmButtonText: "Confirmar"
        })
          .then((result) => {
            if (result.isConfirmed)
              window.location.reload()
          })
      })
      .finally(() => {
        setIsLoading(false)
        setShowModalConfirm(false)
      })
  }

  const validationSchema = yup.object({
    document: yup.string().test('test-invalid-cnpj', 'CNPJ Inválido', (cnpj) => validateDocument("cnpj", cnpj)),
    branches: yup.array().of(yup.object().shape({
      document: yup.string()
        .required("CNPJ é obrigatório")
        .test('test-invalid-cnpj', 'CNPJ da filial Inválido', (cnpj) => validateDocument("cnpj", cnpj))
        .test('test-already-exists-document', 'Revenda ja pertence a um grupo', (cnpj) => {
          if (!cnpj.includes("_")) {
            if (cnpj.length >= 18) {
              if (cancelTokenAvailable)
                cancelTokenAvailable.cancel("Nao precisa mais fazer essas requisicao")

              let mCancelToken = Axios.CancelToken.source()
              setCancelTokenAvailable(mCancelToken)
              return new Promise((resolve, reject) => {
                cnpj = cnpj.replace(/[^\w\s]/gi, '')
                ResalesRequestService.checkIsAvailable(cnpj, { cancelToken: mCancelToken.token })
                .then(({ data }) => {
                  resolve(data.available)
                })
              })
            }
          }
          return true
        })
    })),
    users: yup.array().of(yup.object().shape({
      name: yup
        .string()
        .min(3, "O nome tem que ter no minimo 3 caracteres")
        .required("Nome do usuário é obrigatório"),
      lastname: yup.string()
        .min(3, "O sobrenome tem que ter no minimo 3 caracteres")
        .required("Sobrenome do usuário é obrigatório"),
      email: yup.string()
        .required("Email é obrigatório")
        .email("Email inválido"),
      profile_id: yup.string()
        .required("O perfil do usuário é obrigatório"),
      phone: yup.string()
        .notRequired()
    }))
  })

  const logout = async () => {
    try {
      await LoginService.logout();
    } catch (error) {
    } finally {
      localStorage.clear();
      window.location.reload();
    }
  };

  const toggleMenu = () => {
    setMenuVisible(!menuVisible)
  }

  const handleClose = () => {
    setBranche(null)
    setShowModalSearchCompany(!showModalSearchCompany)
  }

  const addSpecialCharacters = value => {
    return value.replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  return (
    <div className='main'>
      <div className='div-fc'></div>
      <Container className="mt-5 mb-5">
        <Card className='shadow'>
          <Card.Header>
            <div className='d-flex justify-content-between'>
              <h2>Formulário de Adesão - FY25</h2>
              <Button variant="link" onClick={() => logout()}>
                Tentar mais tarde <FontAwesomeIcon icon={faPowerOff} color='#D71925' size='sm' />
              </Button>
            </div>
          </Card.Header>
          <Card.Body>
            <Formik
              enableReinitialize={true}
              validationSchema={validationSchema}
              initialValues={{
                name: company.name ? company.name : "",
                alias: company.alias ? company.alias : "",
                document: company.document,
                address_zipcode: company.address_zipcode ? company.address_zipcode : "",
                address: company.address ? company.address : "",
                address_complement: company.address_complement ? company.address_complement : "",
                address_number: company.address_number ? company.address_number : "",
                address_neighborhood: company.address_neighborhood ? company.address_neighborhood : "",
                address_state: company.address_state ? company.address_state : "",
                address_city: company.address_city ? company.address_city : "",
                branches: branches,
                users: users
              }}
              //onSubmit={_handleSubmit}
              onSubmit={modalConfirm}
            >
              {({ handleSubmit, handleChange, errors, values, setFieldValue, setFieldError }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md="12">
                        <h5 className="title-dashboard">Dados da Revenda</h5>
                        <hr className="line"></hr>
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={6}>
                            <div className='w-100'>
                              <div className='d-flex'>
                                {showCategory(company.is_premium)}
                              </div>
                            </div>
                          </Col>
                          <Col md="6">
                            <Row>
                              <Col md="12">
                                <Form.Group>
                                  <Form.Label>Razão Social:</Form.Label>
                                  <Form.Control
                                    name="name"
                                    as="input"
                                    disabled
                                    value={values.name}
                                    onChange={handleChange}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md="12">
                                <Form.Group>
                                  <Form.Label>Nome Fantasia:</Form.Label>
                                  <Form.Control
                                    name="alias"
                                    as="input"
                                    disabled
                                    value={values.alias}
                                    onChange={handleChange}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md="12">
                                <Form.Group>
                                  <Form.Label>CNPJ:</Form.Label>
                                  <Form.Control
                                    as="input"
                                    disabled
                                    value={maskDocument(values.document)}
                                  />
                                  <ErrorMessage name="document" />
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <h5 className="title-dashboard">Endereço</h5>
                        <hr className="line"></hr>
                      </Col>
                      <Col md={4}>
                        {/* <Form.Group>
                            <Form.Label>CEP:</Form.Label>
                            <Form.Control
                              name="address_zipcode"
                              as="input"
                              onChange={(e) => {
                                if (e.target.value.length >= 8) {
                                  setAddressData(e.target.value)
                                }
                                setAddressZipecode(e.target.value)
                              }}
                              value={maskZip(addressZipcode)}
                            />
                          </Form.Group> */}
                        <Form.Group>
                          <Form.Label>CEP:</Form.Label>
                          <MaskedInput
                            className='form-control'
                            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                            name="address_zipcode"
                            placeholder='00000-000'
                            value={values.address_zipcode}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={8}>
                        <Form.Group>
                          <Form.Label>Av. / Rua:</Form.Label>
                          <Form.Control
                            name="address"
                            as="input"
                            onChange={handleChange}
                            value={values.address}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Número:</Form.Label>
                          <Form.Control
                            name="address_number"
                            as="input"
                            onChange={handleChange}
                            value={values.address_number}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Complemento:</Form.Label>
                          <Form.Control
                            name="address_complement"
                            as="input"
                            onChange={handleChange}
                            value={values.address_complement}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Bairro:</Form.Label>
                          <Form.Control
                            name="address_neighborhood"
                            as="input"
                            onChange={handleChange}
                            value={values.address_neighborhood}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Cidade:</Form.Label>
                          <Form.Control
                            name="address_city"
                            as="input"
                            onChange={handleChange}
                            value={values.address_city}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Estado:</Form.Label>
                          {/* <Form.Control
                              name="address_state"
                              as="input"
                              onChange={handleChange}
                              value={values.address_state}
                            /> */}
                          <Form.Control
                            name="address_state"
                            as="select"
                            onChange={handleChange}
                            value={values.address_state}
                          >
                            <option>AC</option>
                            <option>AL</option>
                            <option>AP</option>
                            <option>AM</option>
                            <option>BA</option>
                            <option>CE</option>
                            <option>DF</option>
                            <option>ES</option>
                            <option>GO</option>
                            <option>MA</option>
                            <option>MT</option>
                            <option>MS</option>
                            <option>MG</option>
                            <option>PA</option>
                            <option>PB</option>
                            <option>PR</option>
                            <option>PE</option>
                            <option>PI</option>
                            <option>RJ</option>
                            <option>RN</option>
                            <option>RS</option>
                            <option>RO</option>
                            <option>RR</option>
                            <option>SC</option>
                            <option>SP</option>
                            <option>SE</option>
                            <option>TO</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className='mt-5 mb-5'>
                      <Col md="12" className="d-flex justify-content-between">
                        <h5 className="title-dashboard">Filiais</h5>
                      </Col>
                      <Col md={12}><hr className="line"></hr></Col>
                      <FieldArray name="branches">
                        {({ remove, push }) => (<>
                          {values.branches && values.branches.length > 0 ? (<>
                            {values.branches.map((branch, idx) => {
                              return (
                                <React.Fragment key={idx}>
                                  <Col md={5}>
                                    <Form.Group>
                                      <Form.Label>{idx + 1} - CNPJ:</Form.Label>
                                      <CNPJ
                                        name={`branches[${idx}].document`}
                                        onChange={(e) => {
                                          var { value: cnpj } = e.target
                                          setFieldValue(`branches[${idx}].document`, cnpj)
                                          setFieldValue(`branches[${idx}].id`, "")
                                          setFieldValue(`branches[${idx}].name`, "")
                                          setFieldValue(`branches[${idx}].alias`, "")
                                          setTimeout(() => {
                                            if (cnpj.length > 0 && !cnpj.includes("_")) {                                            
                                              cnpj = cnpj.replace(/[^\w\s]/gi, '')
                                              ResalesRequestService.verifyAlreadyExists(cnpj, null) 
                                                .then(({ data }) => {
                                                  if (data.status == "error") {
                                                    setFieldError(`branches[${idx}].name`, data.message)
                                                  } else {
                                                    const {company} = data
                                                    setFieldValue(`branches[${idx}].id`, company.id)
                                                    setFieldValue(`branches[${idx}].name`, company.name)
                                                    setFieldValue(`branches[${idx}].alias`, company.alias)
                                                  }
                                                })
                                                .finally(() => {})
                                            }
                                          }, 500)
                                        }}
                                        value={branch.document}
                                      />
                                      {errors.branches ? <span className='text-danger'>{errors.branches[idx]?.document}</span> : null}
                                      {/* <ErrorMessage name={`branches.${idx}.document`} /> */}
                                    </Form.Group>
                                  </Col>
                                  <Col md={3}>
                                    <Form.Group>
                                      <Form.Label>Razão Social:</Form.Label>
                                      <Form.Control
                                        name={`branches[${idx}].name`}
                                        as="input"
                                        onChange={handleChange}
                                        value={branch.name}
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md={3}>
                                    <Form.Group>
                                      <Form.Label>Nome Fantasia:</Form.Label>
                                      <Form.Control
                                        name={`branches[${idx}].alias`}
                                        as="input"
                                        onChange={handleChange}
                                        value={branch.alias}
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md={1}>
                                    <Button style={{ position: 'relative', top: '33px' }} size='sm' variant="danger" onClick={() => {
                                      Swal.fire({
                                        title: 'Tem certeza ?',
                                        icon: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: '#d33',
                                        cancelButtonText: 'Não',
                                        confirmButtonText: 'Sim!'
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                          if (values.branches[idx].id) {
                                            var branchesToDelete = [...companiesToDelete]
                                            branchesToDelete.push(values.branches[idx])
                                            setCompaniesToDelete(branchesToDelete)
                                          }
                                          remove(idx)
                                        }
                                      })
                                    }}>
                                      <Clear fontSize="small" />
                                    </Button>
                                  </Col>
                                </React.Fragment>
                              )
                            })}
                          </>) : <></>}
                          <Col md="12">
                            <Button onClick={() => {
                              push({ id: "", name: "", alias: "", document: "" })
                            }}>
                              <FontAwesomeIcon icon={faPlus} /> Adicionar Filial
                            </Button>
                            {/* <div className={`p-3 d-flex justify-content-start flex-column menu ${menuVisible ? 'show' : ''}`}>
                                <Button className='mb-2' variant="link" onClick={() => {
                                  toggleMenu()
                                  push({ name: "", alias: "", document: "" })
                                }}>
                                  <FontAwesomeIcon icon={faPlus} /> Adicionar Nova
                                </Button>
    
                                <Button variant="link" onClick={() => {
                                  setShowModalSearchCompany(true)
                                }}>
                                  <FontAwesomeIcon icon={faSearch} /> Usar Existente
                                </Button>
                              </div> */}

                            {/* <Modal centered show={showModalSearchCompany} onHide={() => {
                                handleClose()
                                toggleMenu()
                              }}>
                                <Modal.Header>
                                  Buscar pelo CNPJ
                                </Modal.Header>
                                <Modal.Body>
                                  <Row>
                                    <Col md="12">
                                      <Form>
                                        <Form.Group className="mb-3">
                                          <Form.Label>CNPJ:</Form.Label>
                                          <CNPJ
                                            onChange={(e) => {
                                              const cnpj = e.target.value.replace(/[^\w\s]/gi, '').replace('_', '')
                                              if (cnpj.length == 14) {
                                                const CancelToken = Axios.CancelToken;
                                                const source = CancelToken.source();
                                                ResalesRequestService.verifyAlreadyExists(cnpj, source.token)
                                                  .then(({ data }) => {
                                                    setBranche({ ...data.company })
                                                  })
                                                  .catch((err) => {
                                                    Axios.isCancel(err)
                                                  })
                                              }
                                            }}
                                          />
                                          {branche && (<>
                                            <Card className='mt-2'>
                                              <Card.Body>
                                                <ul>
                                                  <li>
                                                    <span className='font-weight-bold'>Status:</span> {branche.company_group_id ?
                                                      <span className='text-danger'>Ja percente à um grupo</span> :
                                                      !values.branches.map(b => b.id).includes(branche.id) ?
                                                        <span className='text-success'>Disponível</span> :
                                                        <span className='text-danger'>Já esta selecionada</span>
                                                    }</li>
                                                  <li><span className='font-weight-bold'>Razão Social:</span> {branche.name}</li>
                                                  <li><span className='font-weight-bold'>Nome Fantasia:</span> {branche.alias} </li>
                                                  <li><span className='font-weight-bold'>CNPJ:</span> {addSpecialCharacters(branche.document)} </li>
                                                </ul>
                                              </Card.Body>
                                              {!branche.company_group_id && !values.branches.map(b => b.id).includes(branche.id) ? (
                                                <Button size="sm" variant="primary" onClick={() => {
                                                  push({ name: branche.name, alias: branche.alias, document: branche.document, id: branche.id })
                                                  handleClose()
                                                  toggleMenu()
                                                }}>
                                                  Selecionar Filial
                                                </Button>) :
                                                (<></>)}
                                            </Card>
                                          </>)}
                                        </Form.Group>
                                      </Form>
                                    </Col>
                                    <Col md="12">
                                      <Button className="mr-3" variant="secondary" onClick={() => {
                                        handleClose()
                                        toggleMenu()
                                      }}>
                                        Cancelar
                                      </Button>
                                    </Col>
                                  </Row>
                                </Modal.Body>
                              </Modal> */}
                          </Col>
                        </>)}
                      </FieldArray>
                    </Row>
                    <Row className='mt-5 mb-5'>
                      <Col md="12" className="d-flex justify-content-between">
                        <h5 className="title-dashboard">Usuários</h5>
                      </Col>
                      <Col md={12}><hr className="line"></hr></Col>
                      <FieldArray name="users">
                        {({ remove, push }) => (<>
                          {values.users && values.users.length > 0 ? (<>
                            {values.users.map((user, idx) => {
                              return (
                                <React.Fragment key={idx}>
                                  <Col md={2}>
                                    <Form.Group>
                                      <Form.Label>{idx + 1} - Nome:</Form.Label>
                                      <Form.Control
                                        size='sm'
                                        name={`users[${idx}].name`}
                                        as="input"
                                        onChange={handleChange}
                                        value={user.name}
                                      />
                                      <ErrorMessage component="span" className='text-danger' name={`users[${idx}].name`} />
                                    </Form.Group>
                                  </Col>
                                  <Col md={2}>
                                    <Form.Group>
                                      <Form.Label>Sobrenome:</Form.Label>
                                      <Form.Control
                                        size='sm'
                                        name={`users[${idx}].lastname`}
                                        as="input"
                                        onChange={handleChange}
                                        value={user.lastname}
                                      />
                                      <ErrorMessage component="span" className='text-danger' name={`users[${idx}].lastname`} />
                                    </Form.Group>
                                  </Col>
                                  <Col md={3}>
                                    <Form.Group>
                                      <Form.Label>Email:</Form.Label>
                                      <Form.Control
                                        size='sm'
                                        name={`users[${idx}].email`}
                                        as="input"
                                        onChange={handleChange}
                                        value={user.email}
                                      />
                                      <ErrorMessage component="span" className='text-danger' name={`users[${idx}].email`} />
                                    </Form.Group>
                                  </Col>
                                  <Col md={2}>
                                    <Form.Group>
                                      <Form.Label>Perfil:</Form.Label>
                                      <Form.Control
                                        size='sm'
                                        as="select"
                                        name={`users[${idx}].profile_id`}
                                        value={user.profile_id}
                                        onChange={handleChange}
                                      >
                                        <option value={null} selected disabled>Selecione o Perfil</option>
                                        <option value="4">Revenda Master</option>
                                        <option value="7">Revenda Visuaizador</option>
                                      </Form.Control>
                                      <ErrorMessage component="span" className='text-danger' name={`users[${idx}].profile_id`} />
                                    </Form.Group>
                                  </Col>
                                  <Col md={2}>
                                    <Form.Group>
                                      <Form.Label>Telefone:</Form.Label>
                                      <MaskedInput
                                        mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                        className='form-control'
                                        name={`users[${idx}].phone`}
                                        placeholder='(00) 0000-0000'
                                        onChange={handleChange}
                                        value={user.phone}
                                      />
                                      <ErrorMessage component="span" className='text-danger' name={`users[${idx}].phone`} />
                                    </Form.Group>
                                  </Col>
                                  <Col md={1}>
                                    <Button style={{ position: 'relative', top: '33px' }} size='sm' variant="danger" onClick={() => {
                                      Swal.fire({
                                        title: 'Tem certeza ?',
                                        icon: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: '#d33',
                                        cancelButtonText: 'Não',
                                        confirmButtonText: 'Sim!'
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                          if (values.users[idx].id) {
                                            var utd = [...usersToDelete]
                                            utd.push(values.users[idx])
                                            setUsersToDelete(utd)
                                          }
                                          remove(idx)
                                        }
                                      })
                                    }}>
                                      <Clear fontSize="small" />
                                    </Button>
                                  </Col>
                                </React.Fragment>
                              )
                            })}
                          </>) : <></>}
                          <Col md="12">
                            <Button onClick={() => push({ name: "", lastname: "", email: "", phone: "" })}>
                              <FontAwesomeIcon icon={faPlus} /> Adicionar Usuário
                            </Button>
                          </Col>
                        </>)}
                      </FieldArray>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <h5>Contrato de Adesão:</h5>
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" checked={contractAccept} onChange={(e) => setContractAccept(e.currentTarget.checked)} />
                          <label className="form-check-label" htmlFor="flexCheckDefault">
                            Li e concordo com o {' '}
                            <a
                              target='_blank'
                              href={contractUri}
                              onClick={() => { }}
                            >Contrato de Adesão</a>
                          </label>
                        </div>
                      </Col>
                      <Col md={12}><hr className="line"></hr></Col>
                    </Row>
                    <Row className='mt-3'>
                      {/* {errors.branches ? (
                        <Col md={12}>
                          <Alert variant="danger">
                            <ul>
                              {errors.branches.map((err, i) => {
                                if (err) {
                                  return (
                                    <li key={i}>{err.document.replace("filial", `filial ${i + 1}`)}</li>
                                  )
                                }
                              })}
                            </ul>
                          </Alert>
                        </Col>
                      ) : null} */}
                      {errors.users ? (
                        <Col md={12}>
                          <Alert variant="danger">
                            <ul>
                              {errors.users.map((err, i) => {
                                if (err) {
                                  return (<>
                                    {err.name ? (<li> {err.name.replace("usuário", `usuário ${i + 1}`)}</li>) : null}
                                    {err.lastname ? (<li>{err.lastname.replace("usuário", `usuário ${i + 1}`)}</li>) : null}
                                    {err.email ? (<li>{err.email.replace("usuário", `usuário ${i + 1}`)}</li>) : null}
                                  </>)
                                }
                              })}
                            </ul>
                          </Alert>
                        </Col>
                      ) : null}
                      <Col md="12">
                        <Button onClick={() => console.log(errors)} disabled={!contractAccept} variant="success" type="submit">Enviar Dados</Button>
                      </Col>
                    </Row>
                  </Form>
                )
              }}

            </Formik>
          </Card.Body>
        </Card>
        <Modal
          size='lg'
          backdrop="static"
          keyboard={false}
          onHide={handleCloseModal}
          show={showModalConfirm && Object.keys(confirmData).length > 0}
        >
          <Modal.Header closeButton>
            <Modal.Title>Verifique os dados antes de enviar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Card className='mb-2'>
              <Card.Body>
                <Card.Title>Dados da Revenda</Card.Title>
                <Table striped bordered className='text-center'>
                  <thead>
                    <tr>
                      <th>Razao Social</th>
                      <th>Nome Fantasia</th>
                      <th>CNPJ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{confirmData.name}</td>
                      <td>{confirmData.alias}</td>
                      <td>{confirmData.document}</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
            <Card className='mb-2'>
              <Card.Body>
                <Card.Title>Endereço</Card.Title>
                <Table striped bordered className='text-center'>
                  <thead>
                    <tr>
                      <th>CEP</th>
                      <th>Av. / Rua</th>
                      <th>Número</th>
                      <th>Complemento</th>
                      <th>Bairro</th>
                      <th>Estado</th>
                      <th>Cidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{confirmData.address_zipcode}</td>
                      <td>{confirmData.address}</td>
                      <td>{confirmData.address_number}</td>
                      <td>{confirmData.address_complement}</td>
                      <td>{confirmData.address_neighborhood}</td>
                      <td>{confirmData.address_state}</td>
                      <td>{confirmData.address_city}</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
            <Card className='mb-2'>
              <Card.Body>
                <Card.Title>Filiais</Card.Title>
                <Table striped bordered className='text-center'>
                  <thead>
                    <tr>
                      <th>Razao Social</th>
                      <th>Nome Fantasia</th>
                      <th>CNPJ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {confirmData.branches?.length == 0 && (
                      <tr>
                        <td colSpan={3}>Sem Filiais</td>
                      </tr>
                    )}
                    {confirmData.branches?.map((branche, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{branche.name}</td>
                          <td>{branche.alias}</td>
                          <td>{branche.document}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
            <Card className='mb-2'>
              <Card.Body>
                <Card.Title>Usuários</Card.Title>
                <Table striped bordered className='text-center'>
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Sobrenome</th>
                      <th>Email</th>
                      <th>Perfil</th>
                      <th>Telefone</th>
                    </tr>
                  </thead>
                  <tbody>
                    {confirmData.users?.map((user, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{user.name}</td>
                          <td>{user.lastname}</td>
                          <td>{user.email}</td>
                          <td>{user.profile_id}</td>
                          <td>{user.phone}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button disabled={isLoading} onClick={() => _handleSubmit(confirmData)}>
              <div className='d-flex align-items-center'>
                <span className={isLoading && 'mr-3'}>Enviar</span>{isLoading && <Spinner animation="border" role="status" size='sm' />}
              </div>
            </Button>
            <Button disabled={isLoading} variant="danger" onClick={handleCloseModal}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div >
  )
}